import React from 'react'
import AtiLogo from './Images/Gov_Logos/ATI-LOGO.png';
import BafLogo from './Images/Gov_Logos/BAF-LOGO.png';
import DoaiLogo from './Images/Gov_Logos/DOAI-LOGO.png'
import DostLogo from './Images/Gov_Logos/DOST-LOGO.jpg';
import PcafLogo from './Images/Gov_Logos/PCAF-LOGO.png';
import TesdaLogo from './Images/Gov_Logos/TESDA-LOGO.png';
import AcpcLogo from './Images/Gov_Logos/ACPC-LOGO.png';
import BarLogo from './Images/Gov_Logos/BAR-LOGO.png';

const Gov = () => {
    return (
        <div className='grid grid-cols-1 md:grid-cols-4 gap-2 mt-2 m-5 p-5'>

            {/*Agricultural Training Institute */}
            <div className='bg-white rounded-xl shadow-2xl mt-10 p-6'>
                <div className='flex justify-center  text-green-600'>
                    <img src={AtiLogo} alt='image' class="object-contain gov-image  " ></img>
                </div>
                <div class="flex p-4 flex-col">
                    <h3 class="font-bold md:text-4xl text-2xl text-center text-green-700 mb-5">
                        <a href='https://ati.da.gov.ph/ati-main/'>Agricultural Training Institute </a>
                    </h3>
                    <p className='text-center font-medium text-xl text-green-600'>For programs and training to promote the development of rural areas. </p>
                </div>
            </div>

            {/*Bureau of Agriculture and Fisheries Standards */}
            <div className='bg-white rounded-xl shadow-2xl mt-10 p-10'>
                <div className='flex justify-center  text-green-600'>
                    <img src={BafLogo} alt='image' class="object-contain gov-image" ></img>
                </div>
                <div class="flex p-4 flex-col">
                    <h3 class="font-bold md:text-4xl text-2xl text-center text-green-700 mb-5">
                        <a href='http://www.bafs.da.gov.ph/'>Bureau of Agriculture and Fisheries Standards</a>
                    </h3>
                    <p className='text-center font-medium text-xl text-green-600'>For quality standards regarding agricultural and fishery products, structure, and machinery</p>
                </div>
            </div>

            {/* Department of Agriculture - Ilocos */}
            <div className='bg-white rounded-xl shadow-2xl mt-10 p-10'>
                <div className='flex justify-center  text-green-600'>
                    <img src={DoaiLogo} alt='image' class="object-contain gov-image" ></img>
                </div>
                <div class="flex p-8 flex-col">
                    <h3 class="font-bold md:text-4xl text-2xl text-center text-green-700 mb-5">
                        <a href='https://ilocos.da.gov.ph/'>Department of Agriculture - Ilocos </a>
                    </h3>
                    <p className='text-center font-medium text-xl text-green-600'>For economic development through agriculture from Region 1.</p>
                </div>
            </div>

            {/* Department of Science and Technology */}
            <div className='bg-white rounded-xl shadow-2xl mt-10 p-10'>
                <div className='flex justify-center  text-green-600'>
                    <img src={DostLogo} alt='image' class="object-contain gov-image" ></img>
                </div>
                <div class="flex p-8 flex-col">
                    <h3 class="font-bold md:text-4xl text-2xl text-center text-green-700 mb-5">
                        <a href='https://region1.dost.gov.ph/'>Department of Science and Technology </a>
                    </h3>
                    <p className='text-center font-medium text-xl text-green-600'>Get information on the latest technology and techniques within Region 1.</p>
                </div>
            </div>

            {/* Philippine Council for Agriculture and Fisheries */}
            <div className='bg-white rounded-xl shadow-2xl mt-10 p-10'>
                <div className='flex justify-center  text-green-600'>
                    <img src={PcafLogo} alt='image' class="object-contain gov-image" ></img>
                </div>
                <div class="flex p-8 flex-col">
                    <h3 class="font-bold md:text-4xl text-2xl text-center text-green-700 mb-5">
                        <a href='http://www.pcaf.da.gov.ph/'>Philippine Council for Agriculture and Fisheries </a>
                    </h3>
                    <p className='text-center font-medium text-xl text-green-600'>For participatory processes in the sector of agriculture and fisheries.</p>
                </div>
            </div>

            {/* Technical Education and skills Authority  */}
            <div className='bg-white rounded-xl shadow-2xl mt-10 p-10'>
                <div className='flex justify-center  text-green-600'>
                    <img src={TesdaLogo} alt='image' class="object-contain gov-image" ></img>
                </div>
                <div class="flex p-8 flex-col">
                    <h3 class="font-bold md:text-4xl text-2xl text-center text-green-700 mb-5">
                        <a href='https://tesda.gov.ph/'>Technical Education and skills Authority </a>
                    </h3>
                    <p className='text-center font-medium text-xl text-green-600'>Read more about technical and skills development programs in the Philippines</p>
                </div>
            </div>

            {/* Agricultural Credit Policy Council*/}
            <div className='bg-white rounded-xl shadow-2xl mt-10 p-10'>
                <div className='flex justify-center  text-green-600'>
                    <img src={AcpcLogo} alt='image' class="object-contain gov-image" ></img>
                </div>
                <div class="flex p-8 flex-col">
                    <h3 class="font-bold md:text-4xl text-2xl text-center text-green-700 mb-5">
                        <a href='https://acpc.gov.ph/'>Agricultural Credit Policy Council </a>
                    </h3>
                    <p className='text-center font-medium text-xl text-green-600'>Find out the agricultural credit policies that are being implemented.</p>
                </div>
            </div>

            {/* Bureau Of Agricultural Research*/}
            <div className='bg-white rounded-xl shadow-2xl mt-10 p-10'>
                <div className='flex justify-center  text-green-600'>
                    <img src={BarLogo} alt='image' class="object-contain gov-image" ></img>
                </div>
                <div class="flex p-8 flex-col">
                    <h3 class="font-bold md:text-4xl text-2xl text-center text-green-700 mb-5">
                        <a href='https://bar.gov.ph/'>Bureau Of Agricultural Research </a>
                    </h3>
                    <p className='text-center font-medium text-xl text-green-600'>Find out the new research available in the farming sector.</p>
                </div>
            </div>

        </div>
    )
}

export default Gov